<template>
  <app-layout>
    <div class="bg-white shadow-lg p-4 lg:p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-7xl mb-10">
      <h1 class="text-3xl md:text-5xl mb-8">{{ $trans('app.menu.privacy-policy') }}</h1>

      <h2>Nous sommes responsable de traitement</h2>
      <p>DSPACE intervient comme responsable de traitement au sens de l’article 4 du RGPD en ce sens qu’elle
        détermine les moyens et finalités des traitements de données nécessaires au fonctionnement du site et à
        la fourniture du service.</p>

      <h2>Vos données</h2>

      <h3>Quelles sont les données que nous collectons ?</h3>
      <p>Les données collectées sont les suivantes :</p>

      <ul>Données d’identité :
        <li>Nom</li>
        <li>Prénom</li>
      </ul>
      <ul>Données de communication :
        <li>Email</li>
        <li>Numéro de téléphone</li>
      </ul>
      <ul>Données financières :
        <li>Numéro de carte bancaire, date d’expiration et CVV</li>
        <li>Pays d’émission de la carte</li>
        <li>Type de carte</li>
      </ul>
      <ul>Autres types de données :
        <li>Réponses aux questions des tests</li>
      </ul>

      <h3>Comment conservons nous vos données ?</h3>
      <p>Les données collectées sont conservées dans une base de donnée sécurisée.</p>

      <h3>Combien de temps conservons nous vos données ?</h3>
      <p>Nous conservons vos données financières et d’identité pour une durée de 5 ans après la fermeture de votre
        compte.</p>

      <h3>Quelle utilisation faisons nous de vos données ?</h3>
      <p>Les données que nous collectons lors de l’utilisation du site sont nécessaire à l’exécution du contrat ou
        à la poursuite de notre intérêt légitime, dans le strict respect de vos droits.</p>

      <ul>Nous utilisons vos données à des fins (les finalités) :
        <li>de gestion du contrat</li>
        <li>de gestion comptable</li>
        <li>d’amélioration du parcours utilisateur</li>
        <li>d’actions marketing</li>
        <li>de lutte contre la fraude.</li>
      </ul>

      <h3>Qui à accès à vos données ?</h3>

      <p>Nous nous efforçons de limiter au maximum les personnes qui peuvent avoir accès à vos données. Nous
        sommes toute fois dans l’obligation de fournir ou de donner accès à vos données à des tiers afin de
        pouvoir vous fournir les services.</p>

      <p>Vous trouverez ci-dessous la liste des personnes physiques ou morales qui ont accès à vos données dans le
        cadre de l’utilisation du site ainsi que l’adresse de leur politique de confidentialité :</p>
      <ul>
        <li>DSPACE (nous), le service technique et vos coachs</li>
        <li>Prestataire de paiement : Stripe Inc. (https://stripe.com/fr/privacy)</li>
        <li>Prestataire d’envoi d’emails : Sendinblue (https://fr.sendinblue.com/legal/privacypolicy/)</li>
        <li>Prestataire de gestion de prise de rendez-vous : Calendly (https://calendly.com/fr/privacy)</li>
      </ul>

      <p>Nous nous engageons à ne pas céder ou louer vos données à des tiers sauf avec votre accord exprès.</p>

      <h2>Transferts hors UE</h2>
      <p>Les données peuvent être amenées à être transférées hors de l’Union Européenne. DSPACE met en place des
        garanties permettant d’assurer la sécurité et la confidentialité des données afin que ce transfert soit
        conforme avec la règlementation.</p>

      <h2>Vos droits</h2>
      <p>Vous avez la possibilité d’exercer vos droits d’accès, de rectification, de suppression, de retrait du
        consentement, de limitation du traitement, d’opposition au traitement ou de portabilité.</p>
      <p>Pour exercer vos droits, il suffit de nous écrire à contact@talents-carriere.fr. Nous nous
        engageons à vous apporter une réponse dans les meilleurs délais.</p>
      <p>Si après nous avoir contacté, vous estimez que nous n’avons pas respecté vos droits, vous pouvez vous
        adresser directement à la Commission Nationale Informatique et Liberté (CNIL) sur le site
        https://www.cnil.fr.</p>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'

export default {
  components: {AppLayout},
}
</script>

<style scoped>
h1, h2, h3 {
  @apply text-dark-blue;
}

h2 {
  @apply mt-6 mb-2 ;
}

h3 {
  @apply my-2;
}

p {
  @apply mb-1;
}

li::before {
  @apply ml-4;
  content: "- ";
}
</style>
